<template>
	<div id="app">
		<el-container>
			<el-header>
				<uiHeader></uiHeader>
			</el-header>
			<el-main>
				<div style="background-color: #FFFFFF; margin-bottom: 1rem; position: relative; padding: 0.5rem; text-align: left;">
					<span style="font-size: 1rem; font-weight: bold;">设备列表</span>
					<div style="position: absolute; right: 1rem; top: 0.3rem;">
						<el-button icon="el-icon-refresh-right" circle size="mini" :loading="getDeviceListLoading" @click="syncDeviceList()"></el-button>
					</div>
          <div style="position: absolute; right: 4rem; top: 0.3rem">
            <el-button icon="el-icon-plus" circle size="mini" @click="addDeviceToGb()"></el-button>
          </div>
				</div>
				<!-- <devicePlayer ref="devicePlayer"></devicePlayer> -->
				<!--设备列表-->
				<el-table :data="deviceList" border style="width: 100%;font-size: 12px;" :height="winHeight">
					<el-table-column prop="name" label="名称"  align="center">
					</el-table-column>
					<el-table-column prop="gbCode" label="设备编号" width="180" align="center">
					</el-table-column>
          <el-table-column label="内网地址" width="180" align="center">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.ip }}</el-tag>
              </div>
            </template>
          </el-table-column>
					<el-table-column prop="manufacturer" label="厂家" align="center">
					</el-table-column>
					<el-table-column label="流传输模式" align="center" width="120">
            <template slot-scope="scope">
              <el-select size="mini" @change="transportChange(scope.row)" v-model="scope.row.streamMode" placeholder="请选择">
                <el-option key="UDP/RTP" label="UDP" value="UDP/RTP"></el-option>
                <el-option key="TCP/RTP" label="TCP" value="TCP/RTP"></el-option>
              </el-select>
            </template>
					</el-table-column>
					<el-table-column prop="channelNum" label="通道数" align="center">
					</el-table-column>
					<el-table-column label="状态" width="120" align="center">
						<template slot-scope="scope">
							<div slot="reference" class="name-wrapper">
								<el-tag size="medium" v-if="scope.row.online == 1">在线</el-tag>
								<el-tag size="medium" type="info" v-if="scope.row.online == 0">离线</el-tag>
							</div>
						</template>
					</el-table-column>
          <el-table-column prop="keepaliveTime" label="最近心跳" align="center" width="140">
          </el-table-column>
          <el-table-column prop="registerTime" label="最近注册" align="center" width="140">
          </el-table-column>
          <el-table-column prop="syncTime" label="同步时间" align="center" width="140">
          </el-table-column>
          <el-table-column prop="modifyTime" label="更新时间" align="center" width="140">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="140">
          </el-table-column>

					<el-table-column label="操作" width="450" align="center" fixed="right">
						<template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.online!=0" icon="el-icon-refresh" @click="refDevice(scope.row)" @mouseover="getTooltipContent(scope.row.deviceId)">刷新</el-button>
							<el-button-group>
                <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="showChannelList(scope.row)">通道</el-button>
                <!-- <el-button size="mini" icon="el-icon-location" v-bind:disabled="scope.row.online==0"  type="primary" @click="showDevicePosition(scope.row)">定位</el-button> -->
                <el-button size="mini" icon="el-icon-edit" type="primary" @click="edit(scope.row)">编辑</el-button>
                <el-button size="mini" icon="el-icon-view" type="primary" @click="view(scope.row)">详情</el-button>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="deleteDevice(scope.row)">删除</el-button>
							</el-button-group>
							</template>
					</el-table-column>
				</el-table>
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="currentChange"
					:current-page="currentPage"
					:page-size="count"
					:page-sizes="[150, 200, 250, 300]"
					layout="total, sizes, prev, pager, next"
					:total="total">
				</el-pagination>
        <deviceEdit ref="deviceEdit" ></deviceEdit>
        <addDeviceDlg ref="addDeviceDlg"></addDeviceDlg>
        <syncChannelProgress ref="syncChannelProgress" ></syncChannelProgress>
        <deviceDetailInfo ref="deviceDetailInfo"></deviceDetailInfo>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import uiHeader from './UiHeader.vue'
  import addDeviceDlg from "./dialog/addDeviceDlg.vue";
	import deviceEdit from './dialog/deviceEdit.vue'
	import syncChannelProgress from './dialog/SyncChannelProgress.vue'
  import deviceDetailInfo from "./dialog/DeviceDetailInfo.vue";

	export default {
		name: 'app',
		components: {
			uiHeader,
      deviceEdit,
      addDeviceDlg,
      syncChannelProgress,
      deviceDetailInfo,
		},
		data() {
			return {
				deviceList: [], //设备列表
				currentDevice: {}, //当前操作设备对象

				videoComponentList: [],
				updateLooper: 0, //数据刷新轮训标志
				currentDeviceChannelsLenth:0,
				winHeight: window.innerHeight - 200,
				currentPage:1,
				count:150,
				total:0,
				getDeviceListLoading: false,
			};
		},
		computed: {
			getcurrentDeviceChannels: function() {
				let data = this.currentDevice['channelMap'];
				let channels = null;
				if (data) {
					channels = Object.keys(data).map(key => {
						return data[key];
					});
					this.currentDeviceChannelsLenth = channels.length;
				}
				return channels;
			}
		},
		mounted() {
			this.initData();
			this.updateLooper = setInterval(this.initData, 10000);
		},
		destroyed() {
			this.$destroy('videojs');
			clearTimeout(this.updateLooper);
		},
		methods: {
			initData: function() {
				this.getDeviceList();
			},
			currentChange: function(val){
				this.currentPage = val;
				this.getDeviceList();
			},
			handleSizeChange: function(val){
				this.count = val;
				this.getDeviceList();
			},
			getDeviceList: function() {
				let that = this;
				this.getDeviceListLoading = true;
				this.$axios({
					method: 'get',
					url:`/api/devices/query`,
					params: {
            page: that.currentPage,
            step: that.count,
            token: this.$cookies.get("session").token,
					}
				}).then(function (res) {
          var data = res.data;
          if( data.code == 0) {
            var ret_data = data.data;
            that.total = ret_data.row_count;
            that.deviceList = ret_data.devices;
          }
          else {
            console.log(data);
          }
          that.getDeviceListLoading = false;
        }).catch(function (error) {
					console.error(error);
					that.getDeviceListLoading = false;
				});

			},
      deleteDevice: function(row) {
        let msg = "确定删除此设备？"
        if (row.online !== 0) {
          msg = "在线设备删除后仍可通过注册再次上线。<br/>如需彻底删除请先将设备离线。<br/><strong>确定删除此设备？</strong>"
        }
        this.$confirm(msg, '提示', {
          dangerouslyUseHTMLString : true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'delete',
            url:`/api/devices/${row.deviceId}/delete`,
            params: {
              token: this.$cookies.get("session").token,
            }
          }).then((res)=>{
            if (res.data.code != 0) {
              that.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              });
            }
            this.getDeviceList();
          }).catch((error) =>{
            console.error(error);
          });
        }).catch(() => {
        });
			},
			showChannelList: function(row) {
				this.$router.push(`/channelList/${row.deviceId}/0/15/1`);
			},
			showDevicePosition: function(row) {
				this.$router.push(`/devicePosition/${row.deviceId}/0/15/1`);
			},

			//gb28181平台对接
			//刷新设备信息
			refDevice: function(itemData) {
				console.log("刷新对应设备:" + itemData.deviceId);
				let that = this;
				this.$axios({
					method: 'post',
					url: '/api/devices/' + itemData.deviceId + '/sync',
          params: {
            token: this.$cookies.get("session").token,
          }
				}).then((res) => {
					console.log("刷新设备结果："+JSON.stringify(res));
					if (res.data.code !==0) {
						that.$message({
							showClose: true,
							message: res.data.msg,
							type: 'error'
						});
					}else{
            that.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success'
            });
            // this.$refs.syncChannelProgress.openDialog(itemData.deviceId)
					}
					that.initData()
				}).catch((e) => {
					console.error(e)
          that.$message({
            showClose: true,
            message: e,
            type: 'error'
          });
				});

			},

      getTooltipContent: async function (deviceId){
         let result = "";
         await this.$axios({
            method: 'get',
            async: false,
            url:`/api/device/query/${deviceId}/sync_status/`,
          }).then((res) => {
           if (res.data.code == 0) {
             if (res.data.data.errorMsg !== null) {
               result = res.data.data.errorMsg
             } else if (res.data.msg !== null) {
               result = res.data.msg
             } else {
               result = `同步中...[${res.data.data.current}/${res.data.data.total}]`;
             }
           }
         })
         return result;
      },
      transportChange: function (row) {
        console.log(`修改传输方式为 ${row.streamMode}：${row.deviceId} `);
        let that = this;
        this.$axios({
          method: 'post',
          url: '/api/device/query/transport/' + row.deviceId + '/' + row.streamMode
        }).then(function(res) {

        }).catch(function(e) {
        });
      },
      edit: function (row) {
        this.$refs.deviceEdit.openDialog(row, ()=>{
          this.$refs.deviceEdit.close();
          this.$message({
            showClose: true,
            message: "设备修改成功，通道字符集将在下次更新生效",
            type: "success",
          });
          setTimeout(this.getDeviceList, 200)
        })
      },
      addDeviceToGb: function () {
        this.$refs.addDeviceDlg.openDialog(() => {
            this.$refs.addDeviceDlg.close();
            this.$message({
                showClose: true,
                message: "设备添加成功",
                type: "success",
            });
            setTimeout(this.getDeviceList, 20);
        });
      },
      syncDeviceList: function () {
        let that = this;
        this.getDeviceListLoading = true;
        this.$axios({
          method: 'post',
          url: "/api/devices/sync",
          params: {
            token: this.$cookies.get("session").token,
          }
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message({
                showClose: true,
                message: "同步成功",
                type: "success",
            });
            that.initData();
          }
          else {
            that.$message.error("同步失败: " + res.data.msg);
          }
        }).catch(function (error) {
            console.log(error);
            that.getDeviceListLoading = false;
        });
      },
      view: function (row) {
          console.log("view " + row.deviceId);
          this.$refs.deviceDetailInfo.openDialog(row.deviceId);
      },
		}
	};
</script>

<style>
	.videoList {
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}

	.video-item {
		position: relative;
		width: 15rem;
		height: 10rem;
		margin-right: 1rem;
		background-color: #000000;
	}

	.video-item-img {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 100%;
		height: 100%;
	}

	.video-item-img:after {
		content: "";
		display: inline-block;
		position: absolute;
		z-index: 2;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 3rem;
		height: 3rem;
		background-image: url("../assets/loading.png");
		background-size: cover;
		background-color: #000000;
	}

	.video-item-title {
		position: absolute;
		bottom: 0;
		color: #000000;
		background-color: #ffffff;
		line-height: 1.5rem;
		padding: 0.3rem;
		width: 14.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/DeviceList.vue